export const LIST_OF_BANKS = 'https://59dc458c-6d95-43b6-8e4b-2f097cd11096.filesusr.com/ugd/3c8bb2_08f9ccaf9acc488b9e6e091bbfa277c5.csv?dn=supported%20institutions%20csv.csv';
